import { IAIVideoModel } from 'types/aiVideo'

export interface ICreditInfo {
  isFree: boolean
  minCredits?: number
}

const collectCredits = (model: IAIVideoModel): number[] =>
  (model.options ?? []).flatMap(option =>
    (option.qualities ?? []).map(quality => quality.credit)
  )

const buildInfo = (positiveCredits: number[]): ICreditInfo => {
  if (!positiveCredits.length) return { isFree: true }
  return { isFree: false, minCredits: Math.min(...positiveCredits) }
}

export const getCreditLabel = (
  models: IAIVideoModel[],
  isUnlimitedById: (modelId: number) => boolean
): ICreditInfo => {
  if (models.some(m => isUnlimitedById(m.id))) return { isFree: true }
  return buildInfo(models.flatMap(collectCredits).filter(credit => credit > 0))
}
